import * as React            from "react";
import {UseState}            from "@Common/react/use-state";

import "./build3.scss";

import {cs}                  from "@Common/react/chain-services";
import {consumeContext,
    provideContext1}         from "@Common/react/context";
import {FComponent}          from "@Common/react/f-component";
import {Load2}               from "@Common/react/load2";
import {isDevXd}             from "@Common/ui-components/debug/is-dev";
import {SessionStorageState} from "@Common/react/session-storage-state";
import {TimeoutAction}       from "@Common/react/timeout-action";
import {downloadProofs}      from "@Common/tools/cc-integration/common/download-proofs";
import {ButtonSpinner}       from "@Common/ui-components/loading-spinners/button-spinner";
import {buildUrlQuery}       from "@Common/utils/build-url-query";
import {parseUrlQuery}       from "@Common/utils/parse-url-query";

import {Button}                     from "./common/button";
import {ScrollControl2}             from "./common/scroll-control-2";
import {CustomizePanel}             from "./customize-panel/customize-panel";
import {ProofPanel}                 from "./proof-panel/proofPanel";
import {ToolsHeader}                from "@Common/ui-components/customization-tools-header/tools-header";
import {ChangeListingModal}         from "../cc-view/change-listing-modal/change-listing-modal";
import {SaveAlerts}                 from "../common/SaveAlerts";
import {InternalInfo}               from "./customize-panel/customize-panel-components/internalInfo";
import {Acknowledgements}           from "./customize-panel/customize-panel-components/acknowledgements";
import {TextSizeAcknowledgement}    from "./customize-panel/customize-panel-components/textSizeAcknowledgement";
import {BreAcknowledgement}         from "./customize-panel/customize-panel-components/breAcknowledgement";
import {OrderBuildManager}          from "./OrderBuildManager";
import {AiWizard}                   from "@Common/ui-components/ai-wizard/ai-wizard-flyout";
import {PropertyWizard}             from "@Common/ui-components/ai-wizard/property-wizard/property-wizard";
import ReactTooltip                 from 'react-tooltip';


interface S {
    saveAlertContent,
    redirecting,
    saveButtonClicked,
    unsavedChanges,
    agent,
    error,
    updatedOrderData
}

interface P {
    apis,
    item,
    templateOptions,
    listing,
    company,
    match
}

export class Build3 extends FComponent<P, S> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            saveAlertContent: null,
            redirecting: null,
            saveButtonClicked: null,
            unsavedChanges: false,
            agent: "",
            error: false,
            updatedOrderData: null
        };
    }
    // Prevent form submission on Enter key press, but allow shift enter presses for soft returns
    // This is to prevent the form from submitting when the user presses enter in a text field
    handleFormKeyDown = (e) => {
        // Allow Shift+Enter key for soft returns
        if (e.shiftKey && e.key === "Enter") {
            return;
        }
        // Allow Enter key for hard returns in textareas
        else if (e.target.tagName === "TEXTAREA") {
            return;
        }
        else if (e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
    };
    render () {
        const {apis, item, templateOptions, listing, company, match} = this.props;

        async function saveDataHandler(saveLoading, event, lastProofDetails) {
            event?.preventDefault();
            saveLoading.onChange(true);
            const data = [];
            const el = event.target.elements;
            const ignoreElements = ["", "order_id", "mceEditor", "listing_name"];
            const hardCharacterLimit = 10000;
            let multiPartFields = {};
            let combinefields = {};
            let combineData = "";
            let ignoreMaxLines = !templateOptions.maxNumberOfLinesAllowed;
            let maxLinesExceeded = false;
            let maxLines = templateOptions.storeMaxNumberOfLinesAllowed;
            let LinesCount = 0;
            let agentSaveDefaultChecked = false;
            let officeReturnAddrChecked = false;
            for (let element of el){
                if (element.className.split(" ").includes("countable") && element.value) {
                    LinesCount++;
                }
            }
            for (let ele of el) {
                if( (maxLines < LinesCount) && !ignoreMaxLines )
                {
                    maxLinesExceeded = true;
                } else if (!ignoreElements.includes(ele.name) && !ele.dataset.multipartfield && !ele.dataset.combinefield && !ele.dataset.ignoreSave){
                    // if type of element is select we need to add a property to the data saved, so we can prevent trimming on the data
                    // There are times where leading/trailing spaces are to be expected from template set up.
                    // If these get trimmed from the saved value, they don't match option so it interferes with display of selected option on pg reload
                    ele.tagName === "SELECT" ?
                        data.push({
                            idContent: ele.name,
                            data: ele.value,
                            label: ele.dataset.fieldname,
                            deleteField: 0,
                            checked: ele.checked,
                            isSelect: true
                        })
                    :
                        data.push({
                            idContent: ele.name,
                            data: ele.value,
                            label: ele.dataset.fieldname,
                            deleteField: 0,
                            checked: ele.checked
                        });
                } else if (ele.dataset.multipartfield) {
                    if (!multiPartFields[ele.name]) {
                        multiPartFields[ele.name] = {idContent: ele.name, deleteField: 0};
                    }
                    multiPartFields[ele.name] = {...multiPartFields[ele.name], [ele.dataset.multipartfield] : ele.value}
                } else if (ele.dataset.combinefield) {
                    combinefields[ele.name] = {
                        idContent: ele.name,
                        [ele.dataset.combinefield]: combineData += ele.value,
                        label: ele.dataset.fieldname,
                        deleteField: 0
                    }
                }
            }

            for (const value in multiPartFields) {
                data.push(multiPartFields[value]);
            }
            for (const value in combinefields) {
                data.push(combinefields[value]);
            }
            if(data.some(item => item.idContent ==='agentSaveDefault'))
            {
                agentSaveDefaultChecked = data.find(item => item.idContent ==='agentSaveDefault').checked;
            }
            if(data.some(item => item.idContent ==='officeReturnAddressDefault'))
            {
                officeReturnAddrChecked = data.find(item => item.idContent ==='officeReturnAddressDefault').checked;
            }
            const modifiedData = data.filter(item => item.idContent !== 'agentSaveDefault' && item.idContent !== 'officeReturnAddressDefault' && 'data' in item).map(field => {
                // This trim doesn't work on TinyMCE fields as there are multiple ways to insert a newline (<br>, <p>, \n, etc).
                // The hard limit on characters will handle the issue we had with failed proofs proofing server being overwhelmed.
                // user will get feedback in the form of the proof to fix any issues with the text having trailing newlines in that case, this is a rare case already.
                // Premedia uses dropdown options of spaces so can't trim all content or it fails required logic.
                let fieldDataTrimmed = field.data?.trim();
                return {
                    ...field,
                    data: ( fieldDataTrimmed && !field.hasOwnProperty("isSelect") ) ? fieldDataTrimmed : field.data
                }
            }

            );
            const fieldWithExceededChars = modifiedData.find(field => field.data?.length > hardCharacterLimit);
            const updatedData = !maxLinesExceeded && !fieldWithExceededChars && await apis.next.OrderManager.updateOrderData(item?.itemId, modifiedData, match.params.component_id).catch(err => {
                this.setState({
                    saveAlertContent: {
                        heading: "SAVE INCOMPLETE",
                        message: "Saving has not been completed. Please check your internet connection and Save again",
                        success: false
                    }
                });
                if (isDevXd()) {
                    console.log("error: ", err);
                }
            });
            if(maxLinesExceeded) {
                this.setState({
                    saveAlertContent: {
                        heading: "SAVE INCOMPLETE",
                        message: "Max number of lines exceeded. Guidelines allow for a maximum of " + maxLines + " lines.",
                        success: false
                    }
                });
            } else if (fieldWithExceededChars) {
                this.setState({
                    saveAlertContent: {
                        heading: "SAVE INCOMPLETE",
                        message: "The field \"" + fieldWithExceededChars.label + "\" exceeds the allowable character limit. Please reduce the characters in the field.",
                        success: false
                    }
                });
            } else {
                this.setState({
                    saveAlertContent: {
                        heading: "CHANGES SAVED",
                        message: "All of your changes have been saved",
                        success: true
                    },
                    unsavedChanges: false,
                    updatedOrderData: updatedData
                });
            }
            const newItem = item;
            if (updatedData?.length) {
                const field65 = updatedData?.find(field => {
                    return item?.programData?.id != 'MAIN' && field.idContent === "field_65";
                });

                if (field65 && field65.data) {
                    newItem['programData']['listingType'] = field65.data;
                    await apis.next.item.updateItem(newItem);
                }

            }
            if(modifiedData?.length)
            {
                const orderName = modifiedData?.find(field => {
                    return field.idContent === "order_name";
                }).data;
                if (item.itemName !== orderName) {
                    newItem['itemName'] = orderName;
                    await apis.next.item.updateItem(newItem);
                }
            }
            saveLoading.onChange(false);
            if (isDevXd()) {
                console.log("modifiedData: ", modifiedData);
                console.log("updatedData: ", updatedData);
            }
            if( agentSaveDefaultChecked )
            {
                const result = await apis.next.session.updateAgent({updateFields: {idAgent: item.idAgent,
                    agentDisplay1: data.find(item => item.idContent === "display_agent_1").data,
                    agentDisplay2: data.find(item => item.idContent === "display_agent_2").data,
                    agentDisplay3: data.find(item => item.idContent === "display_agent_3").data,
                    agentDisplay4: data.find(item => item.idContent === "display_agent_4").data,
                    agentDisplay5: data.find(item => item.idContent === "display_agent_5").data,
                    agentDisplay6: data.find(item => item.idContent === "display_agent_6").data,
                    agentDisplay7: data.find(item => item.idContent === "display_agent_7").data,
                    agentDisplay8: data.find(item => item.idContent === "display_agent_8").data,
                    }});
                if (result?.errorInfo) {
                    this.setState({
                        saveAlertContent: {
                            heading: "SAVE INCOMPLETE",
                            message: result.errorInfo,
                            success: false
                        }
                    });
                }
            }
            if( officeReturnAddrChecked )
            {
                const result = await apis.next.branch.updateBasicInfo({idBranch: item.idBranch,
                    branchDisplay1: data.find(item => item.idContent === "display_branch_1").data,
                    branchDisplay2: data.find(item => item.idContent === "display_branch_2").data,
                    branchDisplay3: data.find(item => item.idContent === "display_branch_3").data,
                    branchDisplay4: data.find(item => item.idContent === "display_branch_4").data,
                    branchDisplay5: data.find(item => item.idContent === "display_branch_5").data,
                    branchDisplay6: data.find(item => item.idContent === "display_branch_6").data,
                    });
                if (result?.errorMessage) {
                    this.setState({
                        saveAlertContent: {
                            heading: "SAVE INCOMPLETE",
                            message: result.errorMessage,
                            success: false
                        }
                    });
                }
            }
            if(this.state.saveButtonClicked === "saveAndExit")
            {
                const idTemplateBack = lastProofDetails?.value?.[0]?.idTemplateBack;
                const skuBack = templateOptions?.sku?.back;
                if (idTemplateBack && idTemplateBack !== skuBack) {
                    this.setState({
                        saveAlertContent: {
                            heading: "TEMPLATE BACK MISMATCH DETECTED",
                            message: "The Template Back has changed since the last proof. Please update your proof before SAVE & EXIT",
                            success: false
                        }
                    });
                    lastProofDetails.reset();
                    saveLoading.onChange(false);
                    return;
                }
            }
            this.setState({saveButtonClicked: null});
        };

        async function proofHandler(isLastProofAvailable, thumbnailBack, thumbnailFront, loading, lastProofError, latestChangesProofed, lastProofDetails) {
            const build3FormSaveButton = document.getElementById("build3FormSave");
            const build3PreviewButton = document.getElementById("build3PreviewButton");
            if (build3FormSaveButton) {
                build3FormSaveButton.focus({preventScroll: true});
                build3FormSaveButton.click();
                build3PreviewButton.focus({preventScroll: true});
            }
            if (loading.value) return;
            loading.onChange(true);
            apis.next.initiateProof( item?.itemId, match.params.component_id )
            .then(async (data) => {
                if (data[0] == "proof complete") {
                    if(match.params.component_id) {
                        /*
                            This call checks proofing_stats and just returns itemThumbnails if there is a recent proof.
                            In case anyone is concerned this is creating a second proof call.
                        */
                        let results = await apis.next.initiateProofing( item?.itemId, match.params.component_id )
                        .then(data => {
                            if (!data['error']) {
                                return data;
                            } else {
                                if (isDevXd()) {
                                    console.log("error", data['error']);
                                }
                                return false;
                            }
                        });
                        if(results?.itemThumbnails?.length) {
                            item.components[match.params.component_id]['itemThumbnails'] = results.itemThumbnails;
                            await apis.next.item.updateItem(item);
                        }
                    }
                    // ✅ Force-refresh proof data before continuing
                    if (lastProofDetails?.reload) {
                        await lastProofDetails.reload();
                    }

                    loading.onChange(false);
                    latestChangesProofed.onChange(true);
                    isLastProofAvailable.onChange([true]);
                    lastProofError.reset();
                    thumbnailBack.reset();
                    thumbnailFront.reset();
                } else {
                    console.log("test");
                    this.setState({
                        saveAlertContent: {
                            heading: "PROOF FAILED",
                            message: "Error while proofing. Please try again.",
                            success: false
                        }
                    });
                    loading.onChange(false);
                }
            });
        };
        async function downloadProofPdfs(itemThumbnails, itemId, buttonName)
        {
            let itemThumbnailsArray = [];
            itemThumbnails = itemThumbnails.filter((item) => item !== null);

            itemThumbnails.map( (image) => {
                let pdfUrl = '';
                if( buttonName == "Download Pdfs" )
                {
                    pdfUrl = image.replace('.jpg', '.pdf&file_type=pdf');
                }
                else
                {
                    //replace the url with proda.pdf and prodb.pdf those are prod files
                    if (image.includes("a.jpg")) {
                        pdfUrl = image.replace('a.jpg', 'proda.pdf&file_type=pdf');
                    } else if (image.includes("b.jpg")) {
                        pdfUrl = image.replace('b.jpg', 'prodb.pdf&file_type=pdf');
                    }
                }
                itemThumbnailsArray.push(pdfUrl);

            })
            if( buttonName == "Download Pdfs" )
            {
            //id we send sides as null then it will download pdf file insteadof zip file
            downloadProofs(itemThumbnailsArray, itemId, null, null);
            }
            else
            {
                downloadProofs(itemThumbnailsArray, itemId, Object.keys(itemThumbnailsArray), null, true);
            }
        }

        function setUnsavedChanges(latestChangesProofed) {
            this.setState({unsavedChanges: true});
            latestChangesProofed.onChange(false);
        }

        return cs(
            consumeContext("apis"),
            consumeContext("session"),
            consumeContext("userLevels"),
            consumeContext("systemConstants"),
            consumeContext("routerHistory"),
            ["branch", ({apis}, next) => Load2({
                fetch: async () => await apis.next.session.getBranch({officeId: item.idBranch}),
                next
            })],
            ["query", (_, next) => next(parseUrlQuery(location.search))],
            ["isInternalUser", ({userLevels}, next) => next(userLevels?.internalUser)],
            ["isDevModeOn", ({isInternalUser}, next) => next(isInternalUser && isDevXd())],
            ["isListingsEligible", ({}, next) => next(templateOptions.options.filter((o) => o.devKey === "listings_eligible")[0]?.value == true ? true : false)],
            ["itemSku", (_, next) => next(!match.params.component_id ? item.sku : item.components[match.params.component_id].sku)],
            ["isLastProofAvailable", ({apis}, next) => Load2({
                fetch: async () => await apis.next.isLastProofAvailable(item?.itemId + (match.params.component_id ? "_" + match.params.component_id: "")),
                next,
            })],
            ["latestChangesProofed", ({}, next) => UseState({
                initValue: false,
                next
            })],
            ["orderBuildData", ({session, itemSku, isListingsEligible, routerHistory, query}, next) => OrderBuildManager({
                item,
                itemSku,
                orderId: item?.itemId,
                session,
                isListingsEligible,
                match,
                routerHistory,
                query,
                setBuild3State: (prop) => this.setState(prop),
                next
            })],
            ["scrollControl", (_, next) => ScrollControl2({next})],
            ["loading", ({}, next) => Load2({
                fetch: async ()=>{false},
                next,
            })],
            ["saveLoading", ({}, next) => UseState({next})],
            ["changeListingModal", ({isListingsEligible}, next) => ChangeListingModal({
                title: listing && Object.keys(listing).length !== 0 ? listing?.location?.streetAddress : "No listing Selected",
                listingId: listing?._id,
                getItem: async () => {
                    return apis.next.item.getItem(match.params.item_id);
                },
                host: null,
                stateId: null,
                clearChanged: () => null,
                orderId: item?.itemId,
                isBuild3: true,
                isListingsEligible: isListingsEligible,
                next,
            })],
            ["textSizeAcknowledgementConf", ({}, next) => UseState({
                initValue: false,
                next
            })],
            ["breAcknowledgementConf", ({}, next) => UseState({
                initValue: false,
                next
            })],
            ["requiredFieldsMissing", ({}, next) => UseState({
                initValue: false,
                next
            })],
            ["emailValidation", ({}, next) => UseState({
                initValue: '',
                next
            })],
            ["requiredImagesMissing", ({}, next) => UseState({
                initValue: false,
                next
            })],
            ["lowResImages", ({}, next) => UseState({
                initValue: false,
                next
            })],
            ({isLastProofAvailable}, next) => isLastProofAvailable.loading ? (
                "Checking proof availability..."
            ) : !isLastProofAvailable.value ? (
                "Error: Cannot get proof availability."
            ) : (
                next()
            ),
            ["thumbnailFront", ({apis, isLastProofAvailable}, next) => Load2({
                fetch: async () => {
                    let componentIncluded = match.params.component_id ? "_" + match.params.component_id : "";
                    if(isLastProofAvailable.value[0] != false)
                        return "/next/proof_display.php?type=proof&path=/proofs/" + item?.itemId + componentIncluded + "/" + item?.itemId + componentIncluded
                            + "a" + ".jpg&salt=" + Math.random();
                    else
                        return await apis.next.getThumbnailData(item?.itemId, "front", match.params.component_id);
                },
                next,
            })],
            ["thumbnailBack", ({apis, isLastProofAvailable}, next) => Load2({
                fetch: async () => {
                    let componentIncluded = match.params.component_id ? "_" + match.params.component_id : "";
                    if(isLastProofAvailable.value[0] != false) {
                        return "/next/proof_display.php?type=proof&path=/proofs/" + item?.itemId + componentIncluded + "/" + item?.itemId + componentIncluded
                            + "b" + ".jpg&salt=" + Math.random();
                    }
                    else
                        return await apis.next.getThumbnailData(item?.itemId, "back", match.params.component_id);
                },
                next,
            })],
            ["numOfSides", ({}, next) => UseState({
                initValue: parseInt(templateOptions?.tempPrefOfNumOfPages),
                next
            })],
            ["lastProofError", ({apis}, next) => Load2({
                fetch: async () => await apis.next.lastProofError(item?.itemId + (match.params.component_id ? "_" + match.params.component_id: "")),
                next,
            })],
            ["lastProofDetails", ({apis}, next) => Load2({
                fetch: async () => await apis.next.lastProofDetails(item?.itemId + (match.params.component_id ? "_" + match.params.component_id: "")),
                next,
            })],
            ["enableLicenseNumber", ({branch}, next) => next(
                branch.value?.enableLicenseNumber ? branch.value?.enableLicenseNumber : company.prefs.enableLicenseNumber
            )],
            ["showBreAcknowledgement", ({enableLicenseNumber}, next) => next(
                enableLicenseNumber === 2 ? true :
                enableLicenseNumber === 1 ? (
                    this.state.updatedOrderData?.find(field => field.idContent === "field_90") &&
                    !this.state.updatedOrderData?.find(field => field.idContent === "field_90")?.data
                ) : false
            )],
            ["showAcknowledgements", ({lastProofError, showBreAcknowledgement}, next) => next(
                lastProofError?.value?.resizing_info || showBreAcknowledgement
            )],
            ["propertyWizardInsertValues", ({}, next) => UseState({
                initValue: {},
                next
            })],
            ({propertyWizardInsertValues}, next) => provideContext1("propertyWizardInsertValues", propertyWizardInsertValues.value, next),
            ["apisLoaded", ({orderBuildData}, next) => next(!orderBuildData.loading)],
            ["isAiEligible", ({orderBuildData}, next) => next(
                (orderBuildData?.contentFields?.value?.some(
                    field => field.idDisplayStyle == 4 || field.idDisplayStyle == 11
                ) || orderBuildData?.specificationFields?.value?.some(
                    field => field.idDisplayStyle == 4 || field.idDisplayStyle == 11
                ))
            )],
            ["isWizardFlyoutOpen", ({}, next) => UseState({
                initValue: false,
                next
            })],
            ["customizePanelLoaded", ({}, next) => UseState({initValue: false, next})],
            ["tooltipContent", ({latestChangesProofed, lastProofError, textSizeAcknowledgementConf, showBreAcknowledgement, breAcknowledgementConf}, next) => next(
                (!latestChangesProofed.value && ( (lastProofError?.value?.resizing_info && !textSizeAcknowledgementConf.value) || (showBreAcknowledgement && !breAcknowledgementConf.value ) )) ? "Please proof & accept acknowledgements to continue" :
                    (!latestChangesProofed.value) ? "Please proof to continue" :
                        ((lastProofError?.value?.resizing_info && !textSizeAcknowledgementConf.value) || (showBreAcknowledgement && !breAcknowledgementConf.value )) ? "Please accept acknowledgements to continue"
                            : ""
            )],
            ["noScroll", ({}, next) => UseState({
                initValue: false,
                next
            })],
            ["errorInWizard", ({}, next) => UseState({
                initValue: false,
                next
            })],
            ({scrollControl, isLastProofAvailable, thumbnailBack, thumbnailFront, loading, saveLoading, orderBuildData, textSizeAcknowledgementConf, breAcknowledgementConf, apisLoaded, isInternalUser,
                isDevModeOn, systemConstants, lastProofError, latestChangesProofed, apis, query, requiredFieldsMissing, emailValidation, requiredImagesMissing, lowResImages, isListingsEligible,
                changeListingModal, itemSku, routerHistory, customizePanelLoaded, enableLicenseNumber, showBreAcknowledgement, showAcknowledgements, isAiEligible, isWizardFlyoutOpen, numOfSides,
                tooltipContent, noScroll, propertyWizardInsertValues, errorInWizard, lastProofDetails
            }) => (
                <div className="build3-24e">
                    {this.state.saveAlertContent?.success && TimeoutAction({
                        delay: 4000,
                        action: () => {
                            this?.setState({saveAlertContent: null});
                            if (this.state.redirecting)  window.location.href = "/app";
                        }
                    })}
                    {this.state.saveAlertContent && (
                        <SaveAlerts
                            message={this.state.saveAlertContent}
                            onClose={() => this.setState({saveAlertContent: null})}
                        />
                    )}
                    {customizePanelLoaded.value &&
                        <ToolsHeader
                            isListingsEligible={isListingsEligible}
                            isAiEligible={isAiEligible}
                            changeListingModal={changeListingModal}
                            listingText={listing?.location?.streetAddress ? listing?.location?.streetAddress : "No listing Selected"}
                            isCC={false}
                            isWizardFlyoutOpen={isWizardFlyoutOpen}
                        />
                     }
                    <form onKeyDown={this.handleFormKeyDown} onSubmit={(e) => {
                        e.preventDefault();
                        if (document.activeElement.id === 'build3FormSave' || document.activeElement.id === 'build3FormSaveAndExit') {
                            let boundSaveDataHandler = saveDataHandler.bind(this, saveLoading, e, lastProofDetails);
                            boundSaveDataHandler();
                        }
                    }}>
                        {emailValidation.value && (
                            <SaveAlerts
                                message={{
                                    heading: "WARNING",
                                    message: emailValidation.value,
                                    success: false
                                }}
                                onClose={() => {emailValidation.onChange('')}}
                            />
                        )}
                        {requiredFieldsMissing.value && (
                            <SaveAlerts
                                message={{
                                    heading: "WARNING",
                                    message: "Some of the required text fields for your order are empty. Please enter text for all required fields.",
                                    success: false
                                }}
                                onClose={() => {requiredFieldsMissing.onChange(false)}}
                            />
                        )}
                        {requiredImagesMissing.value && (
                            <SaveAlerts
                                message={{
                                    heading: "WARNING",
                                    message: "Some of the images for your order are missing. Please insert the missing images before continuing.",
                                    success: false
                                }}
                                onClose={() => {requiredImagesMissing.onChange(false)}}
                            />
                        )}
                        {lowResImages.value && (
                            <SaveAlerts
                                message={{
                                    heading: "WARNING",
                                    message: "Some of the images for your order are too low quality. Please upload higher resolution images.",
                                    success: false
                                }}
                                onClose={() => {lowResImages.onChange(false)}}
                            />
                        )}
                        {isDevModeOn ?
                            <AiWizard
                                idOrder={item?.itemId}
                                isWizardFlyoutOpen={isWizardFlyoutOpen}
                                errorInWizard={errorInWizard.value}
                            >
                                {/* We will pass the tool we want to use in the AiWizard here, & pass as children prop.
                                This ensures the AiWizard doesn't have to know about the tool it contains,
                                or house the logic for deciding which to display.
                                It can act as a wrapper and take whatever we want to send */}
                                <PropertyWizard
                                    idOrder={parseInt(item?.itemId)}
                                    item={item}
                                    idListing={listing?._id}
                                    listing={listing}
                                    changeListingModal={changeListingModal}
                                    isWizardFlyoutOpen={isWizardFlyoutOpen}
                                    eligableContentFields={orderBuildData?.contentFields?.value?.filter(field =>
                                        field.idDisplayStyle == 4 || field.idDisplayStyle == 11
                                    )}
                                    eligableSpecFields={orderBuildData?.specificationFields?.value?.filter(field =>
                                        field.idDisplayStyle == 4 || field.idDisplayStyle == 11
                                    )}
                                    propertyWizardInsertValues={propertyWizardInsertValues}
                                    errorInWizard={errorInWizard}
                                />
                            </AiWizard>
                        : null}
                        <div className="content">
                            <button id="build3PreviewButton" className="preview"
                                type="submit"
                                onClick={async () => await proofHandler.call(this, isLastProofAvailable, thumbnailBack, thumbnailFront, loading, lastProofError, latestChangesProofed, lastProofDetails)}
                            >
                                <ProofPanel
                                    reverseSides={templateOptions.sidesReversed}
                                    thumbnailBack={thumbnailBack.value}
                                    thumbnailFront={thumbnailFront.value}
                                    loading={loading.value}
                                    numOfSides={numOfSides.value}
                                />
                            </button>
                            <div className="customization-fields">
                                {!apisLoaded && <span className="build3-spinner"><ButtonSpinner size={50} spinnerColor="black"/><br/><i>Loading...</i></span>}
                                {apisLoaded && (
                                    <CustomizePanel
                                        orderId={item?.itemId}
                                        item={item}
                                        scrollControl={scrollControl.content}
                                        companyPrefs={company.prefs}
                                        companyProfile={company.profile}
                                        orderData={orderBuildData}
                                        imageFields={orderBuildData.imageFields}
                                        apis={apis}
                                        setUnsavedChanges={setUnsavedChanges.bind(this, latestChangesProofed)}
                                        isListingsEligible={isListingsEligible}
                                        listing={listing}
                                        match={match}
                                        error={this.state.error}
                                        onRendered={() => !customizePanelLoaded.value && customizePanelLoaded.onChange(true)}
                                    />)}
                            </div>
                        </div>
                        <div className="final-proof">
                            <div className="buttons">
                                <Button
                                    type="submit"
                                    btnName={loading.value ? <span><ButtonSpinner spinnerColor="white" /></span> : "Generate Final Proof"}
                                    btnClassName="next"
                                    disabled={loading.value || saveLoading.value}
                                    onClick={async () => {
                                        await proofHandler.call(this, isLastProofAvailable, thumbnailBack, thumbnailFront, loading, lastProofError, latestChangesProofed, lastProofDetails);
                                        this.setState({redirecting: false});
                                    }}
                                    xdQaName="Generate Final Proof Button"
                                />
                                {isLastProofAvailable.value[0] == true && <>
                                    {isInternalUser && (
                                        <Button
                                            type='submit'
                                            btnName={loading.value ? <span><ButtonSpinner spinnerColor="white" /></span> : "Download Prods"}
                                            btnClassName="gray"
                                            disabled={loading.value}
                                            onClick={async () => {
                                                await downloadProofPdfs([thumbnailFront.value, numOfSides.value > 1 ? thumbnailBack.value : null], item?.itemId, "Download Prods" );
                                                this.setState({redirecting: false});
                                            }}
                                            xdQaName="Download Proofs Button"
                                        />
                                    )}
                                    {company?.prefs.allowPdfPreview && (
                                        <Button
                                            type='submit'
                                            btnName={loading.value ? <span><ButtonSpinner spinnerColor="white" /></span> : "Download Pdfs"}
                                            btnClassName="gray"
                                            disabled={loading.value}
                                            onClick={async () => {
                                                await downloadProofPdfs([thumbnailFront.value, numOfSides.value > 1 ? thumbnailBack.value : null], item?.itemId, "Download Pdfs" );
                                                this.setState({redirecting: false});
                                            }}
                                            xdQaName="Download Pdfs Button"
                                        />
                                    )}
                                </>}
                            </div>
                            {showAcknowledgements &&
                                <Acknowledgements>
                                    <>
                                        {lastProofError?.value?.resizing_info  &&
                                            <TextSizeAcknowledgement
                                                agreed={textSizeAcknowledgementConf}
                                                fontSizeWarn={systemConstants.value?.["FONT_SIZE_WARN"]}
                                                errors={lastProofError.value}
                                            />
                                        }
                                        {showBreAcknowledgement &&
                                            <BreAcknowledgement
                                                agreed={breAcknowledgementConf}
                                                enableLicenseNumber={enableLicenseNumber}
                                                loading={loading.value}
                                            />
                                        }
                                    </>
                                </Acknowledgements>
                            }
                        </div>
                        {isInternalUser && <InternalInfo item={item} isBuild3Page={true} ccVersion={''} />}
                        <div className="controls">
                            <div>
                                <Button
                                    btnName="Back"
                                    btnClassName="previous"
                                    disabled={loading.value || saveLoading.value}
                                    onClick={() => {
                                        if( match.params.component_id ) {
                                            routerHistory.push(`/kit-options/order/${item.itemId}` + buildUrlQuery(query));
                                        } else {
                                            routerHistory.push(`/product-options/order/${item?.itemId}` + buildUrlQuery(query));
                                        }
                                        this.setState({redirecting: false});
                                    }}
                                    xdQaName="Back Button"
                                />
                                <Button
                                    id="build3FormSave"
                                    type="submit"
                                    btnName={this.state.saveButtonClicked === "save" ? <span><ButtonSpinner spinnerColor="black" /></span> : "Save"}
                                    btnClassName="gray"
                                    disabled={loading.value || saveLoading.value}
                                    onClick={() => {
                                        this.setState({
                                            redirecting: false,
                                            saveButtonClicked: "save"
                                        });
                                    }}
                                    xdQaName="Save Button"
                                />
                                <Button
                                    id="build3FormSaveAndExit"
                                    btnName={this.state.saveButtonClicked === "saveAndExit" ? <span><ButtonSpinner spinnerColor="black" /></span> : "Save & Exit"}
                                    btnClassName="gray"
                                    disabled={loading.value || saveLoading.value}
                                    onClick={() => {
                                        saveDataHandler.bind(this, saveLoading, lastProofDetails);
                                        this.setState({
                                            redirecting: true,
                                            saveButtonClicked: "saveAndExit"
                                        });
                                    }}
                                    xdQaName="Save And Exit Button"
                                />
                            </div>
                            <div>
                                {(!this.state.unsavedChanges && latestChangesProofed.value) ? (
                                    <Button
                                        type="button"
                                        btnName={loading.value ? <span><ButtonSpinner spinnerColor="white" /></span> : "Continue"}
                                        btnClassName={`next ${tooltipContent ? 'continueBtn' : ''}`}
                                        disabled={loading.value || saveLoading.value || (lastProofError?.value?.resizing_info && !textSizeAcknowledgementConf.value) || (showBreAcknowledgement && !breAcknowledgementConf.value)}
                                        onClick={async () => {
                                            let fieldsValidated, imagesValidated, imagesResolutionValidated, emailValidationMsg;
                                            try{
                                                this.setState({error: false});
                                                fieldsValidated = await apis.next.OrderManager.checkRequiredTextFields(item.itemId, itemSku, match.params.component_id);
                                                emailValidationMsg = await apis.next.OrderManager.checkEmailValidationTextFields(item.itemId, itemSku, match.params.component_id);
                                                imagesValidated = await apis.next.OrderManager.checkRequiredImageFields(item.itemId, itemSku, item.idAgent == "Branch Order" ? 0 : 1, match.params.component_id);
                                                if (isDevXd()) {
                                                    console.log(match.params.component_id);
                                                }
                                                imagesResolutionValidated = await apis.next.OrderManager.checkImageFieldsResolution(item.itemId, {
                                                    'allowLowQualityPhotosHeadshot': company.prefs.allowLowQualityPhotosHeadshot,
                                                    'allowLowQualityPhotosLogo': company.prefs.allowLowQualityPhotosLogo,
                                                    'allowLowQualityPhotosProperty': company.prefs.allowLowQualityPhotosProperty
                                                }, match.params.component_id);
                                                if (fieldsValidated.value && imagesValidated.value && imagesResolutionValidated.value && !emailValidationMsg.value) {
                                                    if( match.params.component_id ) {
                                                        routerHistory.push(`/kit-options/order/${item.itemId}` + buildUrlQuery(query));
                                                    } else {
                                                        routerHistory.push(`/distribution-options/order/${item.itemId}` + buildUrlQuery(query));
                                                    }
                                                }
                                                else {
                                                    setUnsavedChanges.bind(this, latestChangesProofed);
                                                    !fieldsValidated.value && requiredFieldsMissing.onChange(true);
                                                    emailValidationMsg.value && emailValidation.onChange(emailValidationMsg.value);
                                                    !imagesValidated.value && requiredImagesMissing.onChange(true);
                                                    !imagesResolutionValidated.value && lowResImages.onChange(true);
                                                }
                                            }
                                            catch(err){
                                                this.setState({error: true})
                                                if (isDevXd()) {
                                                    console.log("ERROR: ", err);
                                                }
                                            }
                                            this.setState({redirecting: false});
                                        }}
                                        xdQaName="Continue Button"
                                        extraInfo={{"data-tip":tooltipContent, "data-for":"tooltipId"}}
                                    />
                                ) : (
                                    <Button
                                        type="button"
                                        btnName={loading.value ? <span><ButtonSpinner spinnerColor="white" /></span> : "Continue"}
                                        btnClassName="next continueBtn"
                                        disabled={true}
                                        xdQaName="Continue Button new"
                                        extraInfo={{"data-tip":tooltipContent, "data-for":"tooltipId"}}
                                    />
                                )}
                                {
                                    <ReactTooltip
                                        id={"tooltipId"}
                                        place={"bottom"}
                                        effect="solid"
                                        type="dark"
                                    />
                                }
                                {isInternalUser && systemConstants.value?.["ALLOW_SKIP_PROOF"] &&(
                                    <Button
                                        type="button"
                                        btnName="Skip Proof"
                                        btnClassName="gray"
                                        onClick={async () => {
                                            if( match.params.component_id ) {
                                                routerHistory.push(`/kit-options/order/${item.itemId}` + buildUrlQuery(query));
                                            } else {
                                                routerHistory.push(`/distribution-options/order/${item.itemId}` + buildUrlQuery(query));
                                            }
                                        }}
                                        xdQaName="Skip Proof Button"
                                    />
                                )}
                            </div>
                        </div>
                    </form>
                </div>
            )

        )
    }
}
